import { render, staticRenderFns } from "./notifications-dashboard.vue?vue&type=template&id=0f5790aa&scoped=true"
import script from "./notifications-dashboard.vue?vue&type=script&lang=js"
export * from "./notifications-dashboard.vue?vue&type=script&lang=js"
import style0 from "./notifications-dashboard.vue?vue&type=style&index=0&id=0f5790aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5790aa",
  null
  
)

export default component.exports